{
  "network.title": "Nettverk",
  "network.subtitle.one": "{count} verksted",
  "network.subtitle.other": "{count} verksteder",
  "network.nav.overview": "Oversikt",
  "network.nav.kpi": "Nøkkeltall",
  "network.nav.demand": "Etterspørsel",
  "network.nav.health": "Systemhelse",
  "network.nav.audit": "Revisjonslogg",
  "network.error": "Vi fikk ikke hentet nettverksdataene.",
  "network.empty": "Ingenting å vise for dette utvalget.",
  "network.readonly": "Lesemodus. Alt som endres her, gjøres ved å logge inn som noen på verkstedet.",
  "network.data_as_of": "Tallene ble regnet om {when}",
  "network.data_as_of.never": "Tallene er ikke regnet om ennå",
  "network.data_as_of.hint": "Regnes om hver time.",
  "network.filter.country": "Land",
  "network.filter.country.all": "Alle land",
  "network.filter.franchise": "Verksted",
  "network.filter.franchise.all": "Alle verksteder",
  "network.filter.service": "Tjeneste",
  "network.filter.service.all": "Alle tjenester",
  "network.filter.range": "Periode",
  "network.filter.reset": "Nullstill filter",
  "network.range.7": "7 dager",
  "network.range.30": "30 dager",
  "network.range.90": "90 dager",
  "network.range.365": "12 måneder",
  "network.compared_to": "Sammenlignet med {from} – {to}",
  "network.export": "Eksporter CSV",
  "network.export.hint": "Åpnes i Excel med filtrene som er aktive.",
  "network.map.title": "Kart",
  "network.map.planned": "Planlagt marked",
  "network.map.locations.one": "{count} verksted",
  "network.map.locations.other": "{count} verksteder",
  "network.map.legend": "Fargen viser dagens belegg. Ring rundt prikken betyr åpent varsel.",
  "network.column.next_open": "Neste ledige dag",
  "network.column.alerts": "Varsler",
  "network.location.load": "{booked} av {capacity} t booket i dag",
  "network.location.no_capacity": "Stengt i dag",
  "network.location.next_open": "Neste ledige dag {date}",
  "network.location.next_open.none": "Fullbooket så langt vi ser",
  "network.location.open": "Åpne verkstedet",
  "network.alert.integration_degraded": "Kalendersynk ute av drift",
  "network.alert.notifications_failing": "Utsendinger feiler",
  "network.alert.awaiting_approval": "Venter på bekreftelse",
  "network.alert.overbooked": "Overbooket",
  "network.alerts.none": "Ingen varsler",
  "network.metric.bookings": "Bestillinger",
  "network.metric.revenue": "Inntekt",
  "network.metric.utilisation": "Belegg",
  "network.metric.no_show_rate": "Uteblitte",
  "network.metric.cancellation_rate": "Avbestillinger",
  "network.metric.lead_time": "Ledetid",
  "network.metric.job_value": "Snittordreverdi",
  "network.metric.first_response": "Svartid befaring",
  "network.metric.not_applicable": "Kan ikke regnes per tjeneste",
  "network.metric.no_data": "Ingen data",
  "network.delta.better": "{value} bedre enn forrige periode",
  "network.delta.worse": "{value} dårligere enn forrige periode",
  "network.delta.flat": "Uendret mot forrige periode",
  "network.delta.none": "Ingen sammenligning",
  "network.chart.title": "{metric} per dag",
  "network.chart.current": "Valgt periode",
  "network.chart.previous": "Forrige periode",
  "network.chart.table": "Vis som tabell",
  "network.chart.date": "Dato",
  "network.league.title": "Ligatabell",
  "network.league.metric": "Sorter på",
  "network.league.column.rank": "Plass",
  "network.league.column.name": "Verksted",
  "network.league.column.country": "Land",
  "network.league.column.value": "Verdi",
  "network.league.column.trend": "Trend",
  "network.league.column.delta": "Endring",
  "network.demand.title": "Etterspørselskart",
  "network.demand.hint": "Grunnlag for hvor neste verksted skal åpne. Inneholder ingen personopplysninger.",
  "network.demand.postcodes": "Per postnummer",
  "network.demand.services": "Per tjeneste",
  "network.demand.unservable": "Kunne ikke bestilles noe sted",
  "network.demand.unservable.hint": "En forespørsel ingen verksteder kunne ta har ikke noe land, så denne listen vises bare for HQ.",
  "network.demand.column.postcode": "Postnummer",
  "network.demand.column.attempts": "Forsøk",
  "network.demand.column.matched": "Traff",
  "network.demand.column.unservable": "Uten verksted",
  "network.demand.column.converted": "Bestilte",
  "network.demand.column.service": "Tjeneste",
  "network.demand.column.no_slot": "Ingen tid",
  "network.demand.column.nearest": "Nærmeste verksted",
  "network.demand.column.distance": "Avstand",
  "network.demand.column.last_seen": "Sist",
  "network.health.delivery": "E-postlevering",
  "network.health.delivery_rate": "Levert",
  "network.health.sent": "Sendt",
  "network.health.failed": "Feilet",
  "network.health.pending": "Venter",
  "network.health.bounced": "Returnert",
  "network.health.window_24h": "Siste døgn",
  "network.health.window_7d": "Siste uke",
  "network.health.queues": "Køer",
  "network.health.queues.unavailable": "Køen kan ikke leses herfra. Se docs/DEPLOYMENT.md.",
  "network.health.queues.hidden": "Køene er nettverksovergripende og vises bare for HQ.",
  "network.health.integrations": "Integrasjoner per verksted",
  "network.health.integrations.none": "Ingen kalendere er koblet til ennå.",
  "network.health.api": "API",
  "network.health.api.caveat": "Telles i minnet, per prosess, siden {since}. Nullstilles ved hver utrulling.",
  "network.health.api.requests": "Kall",
  "network.health.api.error_rate": "Feilrate",
  "network.health.api.slowest": "Tregeste veier",
  "network.health.failed_jobs": "Feilede utsendinger",
  "network.health.column.queue": "Kø",
  "network.health.column.route": "Vei",
  "network.health.column.p95": "p95",
  "network.health.column.attempts": "Forsøk",
  "network.health.column.error": "Feil",
  "network.health.all_clear": "Ingenting å utbedre.",
  "network.audit.filter.entity": "Objekt",
  "network.audit.filter.action": "Handling",
  "network.audit.filter.all": "Alle",
  "network.audit.column.when": "Tidspunkt",
  "network.audit.column.action": "Handling",
  "network.audit.column.entity": "Objekt",
  "network.audit.column.actor": "Utført av",
  "network.audit.column.franchise": "Verksted",
  "network.audit.column.ip": "IP",
  "network.audit.impersonated": "via {email}",
  "network.audit.system": "Systemet",
  "network.audit.more": "Vis flere",
  "network.detail.settings": "Innstillinger",
  "network.detail.staff": "Ansatte og ressurser",
  "network.detail.notifications": "Utsendinger, 30 dager",
  "network.detail.integrations": "Integrasjoner",
  "network.detail.hours": "Åpningstider",
  "network.detail.closed": "Stengt",
  "network.detail.confirm.auto": "Bekreftes automatisk",
  "network.detail.confirm.manual": "Bekreftes manuelt",
  "network.detail.notice": "Korteste varsel",
  "network.detail.horizon": "Kan bestilles {days} dager fram",
  "network.detail.granularity": "Tidssteg {minutes} min",
  "network.detail.cancellation": "Avbestilling til {hours} t før",
  "network.detail.services": "{enabled} av {total} tjenester på",
  "network.detail.calendar": "Åpne kalenderen",
  "network.detail.back": "Tilbake til nettverket",
  "network.detail.no_staff": "Ingen ansatte lagt inn ennå.",
  "network.create.open": "Nytt verksted",
  "network.create.title": "Legg inn et verksted",
  "network.create.body": "Tidssone, språk og valuta følger av landet. Verkstedet legges inn under oppstart og vises ikke i bookingen før det aktiveres.",
  "network.create.identity": "Verkstedet",
  "network.create.identity_body": "Navnet kundene ser, og opplysningene e-postene og fakturaene bygger på.",
  "network.create.place": "Sted",
  "network.create.place_body": "Der kunden møter verkstedet — på kartet og i søket etter nærmeste verksted.",
  "network.create.optional": "valgfritt",
  "network.create.country": "Land",
  "network.create.country_hint": "Bestemmer tidssone, språk og valuta. Kan ikke endres etterpå.",
  "network.create.display_name_hint": "Navnet kunden ser i bookingen, på kartet og i e-postene.",
  "network.create.slug": "Adressenavn",
  "network.create.slug_hint": "Ligger i bookinglenken og i hver e-post som er sendt. Velg riktig med en gang.",
  "network.create.slug_preview": "Bookinglenken blir /boka/{slug} og kan ikke endres etterpå.",
  "network.create.legal_name": "Juridisk navn",
  "network.create.legal_name_hint": "Selskapsnavnet. Vises aldri for kunden.",
  "network.create.org_nr": "Organisasjonsnummer",
  "network.create.mode": "Type virksomhet",
  "network.create.mode.fixed": "Fast verksted",
  "network.create.mode.mobile": "Ambulerende",
  "network.create.mode.hybrid": "Både fast og ambulerende",
  "network.create.mode_hint.fixed": "Kunden kommer hit. Gateadressen må fylles ut.",
  "network.create.mode_hint.mobile": "Teknikeren drar til kunden. Adressen er utgangspunktet og er valgfri — radiusen nedenfor avgjør hvem som kan booke.",
  "network.create.mode_hint.hybrid": "Kunden kan komme hit og teknikeren kan dra ut. Radiusen nedenfor avgjør hvor langt dere drar.",
  "network.create.geo": "Koordinater",
  "network.create.geo_hint": "Lim inn begge tallene på én gang i Breddegrad, så deler vi dem opp. Vi slår ikke opp adresser — kartet og søket etter nærmeste verksted bygger på disse to tallene.",
  "network.create.hours_copy": "Kopier {day} til alle åpne dager",
  "network.create.missing": "Igjen å fylle ut:",
  "network.create.services_note": "Hele tjenestekatalogen slås på til nettverkets priser. Verkstedet justerer selv etterpå.",
  "network.create.submit": "Legg inn verkstedet",
  "network.create.created": "{name} er lagt inn. Inviter eieren og aktiver når alt stemmer.",
  "network.create.error": "Vi fikk ikke lagt inn verkstedet.",
  "network.create.slug_taken": "Adressenavnet er opptatt.",
  "network.create.check_fields": "Kontroller feltene som er markert.",
  "network.create.invalid": "Kontroller dette feltet.",
  "network.create.slug_format": "Bare a–z, 0–9 og bindestrek. Ingen å, æ, ø eller mellomrom.",
  "network.unit.hours": "{count} t",
  "network.unit.minutes": "{count} min",
  "network.unit.days": "{count} d",
  "network.unit.percent": "{value} %",
  "network.status.onboarding": "Under oppstart",
  "network.status.paused": "Verkstedet er fjernet fra bookingen.",
  "network.status.paused_with_bookings": "Verkstedet er fjernet fra bookingen. {count} bookede tider står igjen og må håndteres.",
  "network.status.activated": "Verkstedet er i gang og vises i bookingen.",
  "network.status.activate": "Aktiver verkstedet",
  "network.status.needs_staff": "Legg inn minst én bookbar person eller enhet før verkstedet aktiveres.",
  "network.status.error": "Vi fikk ikke endret status.",
  "network.danger.title": "Risikosone",
  "network.danger.body": "Fjern verkstedet fra bookingen. Det forsvinner fra finn-verksted og kan ikke bookes, men kalender, historikk og tall blir liggende.",
  "network.danger.paused_body": "Verkstedet er fjernet fra bookingen. Aktiver det igjen når det skal ta imot kunder.",
  "network.danger.remove": "Fjern fra bookingen",
  "network.danger.confirm_title": "Fjerne verkstedet fra bookingen?",
  "network.danger.confirm_body": "Kunder kan ikke lenger finne eller booke dette verkstedet. Allerede bookede tider avbestilles ikke — ring kundene. Ingenting slettes, og du kan aktivere verkstedet igjen.",
  "network.danger.type_slug": "Skriv {slug} for å bekrefte",
  "network.status.removed": "Fjernet fra bookingen",
  "network.danger.copy_slug": "Kopier {slug}",
  "network.danger.copied": "Navnet er kopiert.",
  "network.column.status": "Status",
  "network.status.active": "I drift",
  "network.reports.title": "Rapporter til deg",
  "network.reports.body": "Få nettverkets eller et lands tall på e-post automatisk.",
  "network.reports.scope": "Omfang",
  "network.reports.scope.network": "Hele nettverket",
  "network.reports.self_only": "Rapporten sendes til din egen adresse.",
  "network.nav.reports": "Rapporter",
  "network.nav.integrations": "Integrasjoner",
  "network.integrations.body": "Leverandører verkstedene kan velge for påminnelser til kunder. Bare HQ ser nøklene, og bare HQ betaler.",
  "network.integrations.unavailable": "Meldinger er ikke slått på i dette miljøet.",
  "network.integrations.email.managed": "Resend · Håndteres av ColorGlo HQ",
  "network.integrations.elks46.username": "API-brukernavn",
  "network.integrations.elks46.password": "API-passord",
  "network.integrations.elks46.sender.hint": "3–11 bokstaver eller tall, uten mellomrom, og starter med en bokstav, for eksempel ColorGlo. Brukes når verkstedet ikke har satt sitt eget avsendernavn.",
  "network.integrations.hint": "Nøkkel ••••{hint}",
  "network.integrations.used_by.one": "Brukes av {count} verksted",
  "network.integrations.used_by.other": "Brukes av {count} verksteder",
  "network.integrations.enabled": "Tilgjengelig for verksteder",
  "network.integrations.enabled.needs_verify": "Test tilkoblingen før leverandøren kan slås på.",
  "network.integrations.verify": "Test tilkobling",
  "network.integrations.verified": "Tilkoblingen fungerer.",
  "network.integrations.send_test": "Send test til meg",
  "network.integrations.test_sent": "Testmeldingen er sendt.",
  "network.integrations.replace": "Bytt nøkler",
  "network.integrations.replace.hint": "Leverandøren slås av til den nye nøkkelen er testet.",
  "network.integrations.saved": "Lagret.",
  "network.integrations.failure.credentials_rejected": "Leverandøren godtok ikke nøklene.",
  "network.integrations.failure.unreachable": "Leverandøren svarte ikke. Prøv igjen om litt.",
  "network.integrations.failure.unexpected": "Noe gikk galt hos leverandøren.",
  "network.integrations.test_phone": "Mobilnummer for testen",
  "network.integrations.test_phone.hint": "Med landskode, for eksempel +4791234567.",
  "network.integrations.test_dry_run": "Testmodus: ingen SMS ble sendt og ingenting kostet. Sett SMS_REDIRECT_TO for å få ekte test-SMS.",
  "network.integrations.field.sender": "Standardavsender",
  "network.integrations.field.sender.optional": "Valgfritt. 3–11 bokstaver eller tall. Må være godkjent i Prelude-kontoen deres. La stå tomt for kontoens standard.",
  "network.integrations.field.api_key": "API-nøkkel",
  "network.integrations.field.test_template_id": "Mal-ID for testmeldingen",
  "network.integrations.field.test_template_id.hint": "En mal uten variabler, for eksempel template_01k8…. Be Prelude lage den.",
  "network.integrations.field.access_token": "Tilgangstoken (permanent systembrukertoken)",
  "network.integrations.field.phone_number_id": "Telefonnummer-ID",
  "network.integrations.field.phone_number_id.hint": "Sifrene under WhatsApp → API Setup i Meta, ikke selve telefonnummeret.",
  "network.integrations.field.test_template_name": "Mal for testmeldingen",
  "network.integrations.field.test_template_name.hint": "hello_world finnes i alle WhatsApp-kontoer fra start.",
  "network.integrations.field.test_template_language": "Malens språkkode",
  "network.integrations.field.template.booking_confirmed": "Mal-ID: bookingbekreftelse (colorglo_booking_confirmed)",
  "network.integrations.field.template.reminder": "Mal-ID: påminnelse (colorglo_reminder)",
  "network.integrations.field.template.rescheduled": "Mal-ID: flyttet time (colorglo_rescheduled)",
  "network.integrations.field.template.cancelled": "Mal-ID: avbestilt time (colorglo_cancelled)",
  "network.integrations.field.template.hint": "Fra Prelude etter at malene i docs/messaging/prelude-templates.csv er lastet opp. Uten ID sendes ikke den typen melding.",
  "network.nav.costs": "Kostnader",
  "network.costs.title": "Meldingskostnader",
  "network.costs.body": "SMS og WhatsApp per verksted og måned. Bare HQ ser denne siden. Beløp i ulike valutaer legges aldri sammen.",
  "network.costs.previous": "Forrige måned",
  "network.costs.next": "Neste måned",
  "network.costs.sent": "Sendt",
  "network.costs.failed": "Mislykket",
  "network.costs.skipped": "Hoppet over",
  "network.costs.cost": "Kostnad",
  "network.costs.total": "Totalt {currency}",
  "network.costs.workshop": "Verksted",
  "network.costs.provider": "Leverandør",
  "network.costs.paused": "Slått av",
  "network.costs.empty": "Ingen SMS eller WhatsApp-meldinger denne måneden.",
  "network.costs.without_cost": "{count} uten rapportert kostnad",
  "network.integrations.field.account_sid": "Account SID",
  "network.integrations.field.auth_token": "Auth Token",
  "network.integrations.field.sender.twilio": "Et avsendernavn på 3–11 bokstaver eller tall, for eksempel ColorGlo, eller et Twilio-nummer med landskode (+47…). Brukes når verkstedet ikke har satt sitt eget.",
  "network.owner.title": "Eier",
  "network.owner.description": "Invitasjonen går til verkstedets egen e-postadresse. Eieren velger bare et passord.",
  "network.owner.state.none": "Ingen eier",
  "network.owner.state.invited": "Invitert – utløper {date}",
  "network.owner.state.active": "Aktiv",
  "network.owner.send": "Send invitasjon",
  "network.owner.resend": "Send igjen",
  "network.owner.revoke": "Trekk tilbake",
  "network.owner.sent": "Invitasjon sendt til {email}",
  "network.owner.link": "Lenken vises bare nå. Del den hvis e-posten ikke kommer frem.",
  "network.owner.copy": "Kopier lenke",
  "network.owner.copied": "Lenken er kopiert",
  "network.owner.error": "Det gikk ikke. Prøv igjen."
}
